import DepStore from "@/vuex/index";
import VueRouter from "vue-router";

import {
  CallCenterBankStatement,
  CallCenterNewRelative,
  CallCenterTransactions,
  CategoriesList,
  DepClassesForm,
  DepClassesModal,
  DepClassesSection,
  DepCustomClassesForm,
  DepCustomSubjectsSection,
  DepDocumentsSection,
  DepEvaluationModelsForm,
  DepGradeSingleSection,
  DepGroupGrowthCardList,
  DepGroupsForm,
  DepGroupsSection,
  DepNotFound,
  DepNotificationsForm,
  DepNotificationsSection,
  DepPathwayCardList,
  DepStudentsForm,
  DepUsersForm,
  Followup,
  Home,
  Login,
  Planner,
  Knotionbank,
  ResourceList,
  RootMenuList,
  SearchResult,
  DepGradeReportPage,
  MainApp,
  Dashboard,
  DepReportGrade,
  RetrievePassword,
  Forbidden,
} from "./lib/lazyLoadRoutes";
import { userRoutes } from "./routes/users_routes";
import { depPaymentRoutes } from "./routes/dep_payments_routes";
import { profileParentsRoutes } from "./routes/dep_parents_routes";
import { evaluationPeriodRoutes } from "./routes/evaluation_period_routes";
import { evaluationCriteriaRoutes } from "./routes/evaluation_criteria_routes";
import { settingsRoutes } from "./routes/settings_routes";
import { kardexRoutes } from "./routes/kardex_routes";
import { signUpWizardRoutes } from "./routes/signup_wizard_routes";
import KnGuardianMiddleware from "./features/dep-parents/payments/presentation/views/KnGuardianMiddleware.vue";

const unauthPaths = [
  "/payments/confirm",
  "/payments/wizard",
  "/retrievePassword",
  "/3DSecureResponse",
  "/knguardian/payments",
];

const router = new VueRouter({
  mode: "history",
  linkActiveClass: "active",
  routes: [
    {
      path: "/login",
      component: Login,
    },
    {
      path: "/retrievePassword",
      component: RetrievePassword,
    },
    {
      path: "/knguardian/payments",
      component: KnGuardianMiddleware, //TODO: move this to payment routes when ready
    },
    {
      path: "/",
      component: MainApp,
      children: [
        ...userRoutes,
        ...depPaymentRoutes,
        ...profileParentsRoutes,
        ...evaluationPeriodRoutes,
        ...evaluationCriteriaRoutes,
        ...settingsRoutes,
        ...kardexRoutes,
        ...signUpWizardRoutes,
        {
          path: "/",
          redirect: "/dashboard",
        },
        {
          path: "/dashboard",
          component: Home,
          children: [
            { path: "/", component: Dashboard, name: "home" },
            {
              path: "/report-grade",
              name: "report-grade",
              component: DepReportGrade,
            },
          ],
        },
        {
          path: "/planner",
          component: Planner,
        },
        {
          path: "/Knotion-bank",
          component: Knotionbank,
        },
        {
          path: "/followup",
          component: Followup,
          children: [
            {
              name: "follow-pathways",
              path: "/",
              alias: "class-progress",
              component: DepPathwayCardList,
            },
            {
              name: "follow-groups",
              path: "groups-scores",
              component: DepGroupGrowthCardList,
            },
          ],
        },
        {
          path: "/notifications",
          component: DepNotificationsSection,
        },
        {
          path: "/notifications/new",
          component: DepNotificationsForm,
        },
        {
          path: "/notifications/edit/:id",
          component: DepNotificationsForm,
        },
        {
          path: "/documents",
          component: DepDocumentsSection,
          children: [
            {
              path: "/",
              component: RootMenuList,
              props: true,
            },
            {
              path: "search",
              component: SearchResult,
              props: true,
            },
            {
              path: "categories",
              component: CategoriesList,
              props: true,
            },
            {
              path: "categories/:category",
              component: CategoriesList,
              props: true,
            },
            {
              path: "categories/:category/resources/:resource",
              component: ResourceList,
              props: true,
            },
          ],
        },
        {
          path: "/boleta-beta",
          name: "report",
          component: DepGradeReportPage,
        },
        {
          path: "/personal-growth",
          component: DepGradeSingleSection,
        },
        {
          path: "/users/new",
          component: DepUsersForm,
        },
        {
          path: "/users/edit/:id",
          component: DepUsersForm,
        },
        {
          path: "/users/massive",
          component: DepStudentsForm,
        },
        {
          path: "/classes",
          component: DepClassesSection,
        },
        {
          path: "/classes/edit/:id",
          component: DepClassesForm,
        },
        {
          path: "/classes/new",
          component: DepCustomClassesForm,
        },

        {
          path: "/groups",
          component: DepGroupsSection,
        },
        {
          path: "/groups/edit/:id",
          component: DepGroupsForm,
        },
        {
          path: "/groups/new",
          component: DepGroupsForm,
        },

        { path: "/modalC", component: DepClassesModal },
        {
          path: "/evaluation/custom-subjects",
          component: DepCustomSubjectsSection,
        },

        // EVALUATION
        {
          path: "/evaluation/models/new",
          component: DepEvaluationModelsForm,
        },
        {
          path: "/evaluation/models/edit/:id",
          component: DepEvaluationModelsForm,
        },
        {
          path: "/callcenter/accountStatus",
          component: CallCenterBankStatement,
        },
        {
          path: "/callcenter/transactions",
          component: CallCenterTransactions,
        },
        {
          path: "/callcenter/relative/new",
          component: CallCenterNewRelative,
        } /* 

        {
          path: "/callcenter/users",
          component: CallCenterUsers,
        } /* 
        {
          path: "/callcenter/users/new",
          component: CallCenterUsersEdit,
        },
        {
          path: "/callcenter/users/edit/:id",
          component: CallCenterUsersEdit,
        },
        {
          path: "/callcenter/users/massive",
          component: CallCenterStudentsForm,
        }, */,
        {
          path: "/forbidden",
          component: Forbidden,
        },
        {
          //! Show not found with dep menu
          path: "*",
          component: DepNotFound,
        },
      ], // Main Layout Children
    },
    {
      path: "/evaluation/models/edit/:id",
      component: DepEvaluationModelsForm,
    },
    {
      path: "*",
      component: DepNotFound,
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  router.app.$modal.hideAll(); //! Close all modals on navigate (browser navigation applies too)

  const isUserLoggedIn = DepStore.getters["User/isLoggedIn"];

  if (isUserLoggedIn && to.path == "/login") {
    next("/");
    return;
  }

  if (unauthPaths.some((url) => to.path.startsWith(url))) {
    next((vm) => {
      vm.$ga.page(to.path);
    });
    return;
  }

  if (!isUserLoggedIn && to.path !== "/login") {
    next("/login");
  }

  // prevent user access to login page if already logged in
  // if (isUserLoggedIn && to.path == "/login") {
  //   next("/");
  // }

  await DepStore.dispatch("User/loadUser");
  const isCallCenter = DepStore.getters["User/isCallCenter"];
  const isStudent = DepStore.getters["User/isStudent"];
  const isCommunication = DepStore.getters["User/isKnCom"];
  const dashboardPaths = ["/", "/dashboard"];

  //! Students have not access to dep
  if (isStudent && to.path != "/forbidden" && to.path != "/login") {
    return next("/forbidden");
  }

  //! Communication users have access to notifications only
  if (
    isCommunication &&
    !to.path.startsWith("/notifications") &&
    to.path != "/login"
  ) {
    return next("/notifications");
  } // Test

  //! Redirect callcenter users to transactions page by default
  if (dashboardPaths.includes(to.path) && isCallCenter) {
    return next("/callcenter/transactions");
  } else {
    next((vm) => {
      /* Google Analytics tracks navigation behavior */
      vm.$ga.page(to.path);
    });
  }
});

export default router;
